//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';

const Module = ({ name, children }) => {
 
    const setInnerHTML = (value) => {
        return { __html: value};
    };
    
    return (
        <div className="casa-dashboard-row row">
            <div className="col-lg-12 col-md-12 col-xs-12">
                <h2 className="au-display-lg" dangerouslySetInnerHTML={setInnerHTML(name)}></h2>
            </div>

            {children}

        </div>
    );

}

Module.propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired])
};

export default Module;
